import React, { useState, useEffect } from "react";
import classNames from "classnames/bind";
import { Bell, Verifyok } from "../../icons/";
import { Button, Nav } from "react-bootstrap";
import { Page } from "../../model";
import WarrantVerifyModel from '../../components/WarrantVerifyModel';
import style from "./index.module.css";
import axios from "axios";
import { getCampaignQuery } from "../../api/newApi/getCampaignQuery";

const cx = classNames.bind(style);

export interface NavigationProps {
  pageButton: Page;
  onPageButtonClick: (page: Page) => void;
  orderCount: number;
  onorderCountClick: () => void;
  cuid: string | null;
  verify: boolean;
  code: string;
}
const Navigation: React.FC<NavigationProps> = ({
  pageButton,
  onPageButtonClick,
  orderCount,
  onorderCountClick: onOrderCountClick,
  cuid,
  verify = false,
  code,
}) => {
  const [isWarrantVerifyModalOpen, setIsWarrantVerifyModalOpen] = useState(false); //實際登錄modal
  const [isStundentIDVerifyModelOpen, setIsStundentIDVerifyModelOpen] = useState(false); //學生證件modal
  const [showQueryResult, setShowQueryResult] = useState(false);
  const [cuIdForTradeLogin, setCuIdForTradeLogin] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [shouldOpenModal, setShouldOpenModal] = useState<boolean>(false);

  const handleWarrantVerifyModalOpen = async () => {
    setShowQueryResult(false);
    setLoading(true);

    if (!cuIdForTradeLogin) {
      try {
        const response = await getCampaignQuery(axios);
        if (response && response.cu_id) {
          setCuIdForTradeLogin(response.cu_id);
        } else {
          console.error("Failed to fetch cu_id");
        }
      } catch (error) {
        console.error("api error", error);
      } finally {
        setLoading(false);
        if (cuIdForTradeLogin) {
          setIsWarrantVerifyModalOpen(true);
        }
      }
    }

    else {
      setLoading(false);
      setIsWarrantVerifyModalOpen(true);
    }
    setShouldOpenModal(true);
  };

  useEffect(() => {
    if (shouldOpenModal && cuIdForTradeLogin) {
      setIsWarrantVerifyModalOpen(true);
      setShouldOpenModal(false);
    }
  }, [cuIdForTradeLogin, shouldOpenModal]);

  const handleWarrantVerifyModalClose = () => {
    setIsWarrantVerifyModalOpen(false);
  };

  const orderInquireOnClick = () => {
    onPageButtonClick("orderInquire");
    onOrderCountClick();
  };

  const isSchoolCampaign = (window.parent as any).location.href.includes("tradSchoolCampaign");
  const hasCuid = !!cuid && !loading;
  return (
    <>
      <div
        className={cx("desktop-hide")}
        style={{ paddingBottom: "5px" }}
        onClick={() => {
          onPageButtonClick("gameIndex");
        }}
      >
        <Button
          variant="outline-primary"
          className={cx(
            "min-width-55px",
            "w-100",
            "btn-radius",
            pageButton === "gameIndex" ? "active" : ""
          )}
        >
          {isSchoolCampaign ? "課程首頁" : "活動首頁"}
        </Button>
      </div>
       {/* {!isSchoolCampaign && (
        <div className={cx("desktop-hide")} style={{ paddingBottom: "5px" }}>
          <Button
            variant="outline-primary"
            className={cx("min-width-55px", "w-100", "btn-radius", "mobile-hide")}
            onClick={handleWarrantVerifyModalOpen}
            disabled={loading}
          >
            權證實際交易登錄
          </Button>
        </div>
      )}  */}
      
<Nav
  className={cx(
    hasCuid ? "justify-content-evenly" : "justify-content-between",
    "desktop-w",
    "mobile-hide"
  )}
>
  <Nav.Item
    className={cx("mobile-hide")}
    onClick={() => {
      onPageButtonClick("gameIndex");
    }}
  >
    <Button
      variant="outline-primary"
      className={cx(
        "nav-rounded",
        "customizedPadding",
        pageButton === "gameIndex" ? "active" : ""
      )}
    >
      {isSchoolCampaign ? "課程首頁" : "活動首頁"}
    </Button>
  </Nav.Item>
     {/* {!isSchoolCampaign && (
            <Nav.Item className={cx("mobile-hide")}>
              <Button
                variant="outline-primary"
                className={cx("nav-rounded", "customizedPadding")}
                onClick={handleWarrantVerifyModalOpen}
                disabled={loading}
              >
                權證實際交易登錄
              </Button>
            </Nav.Item>
          )}  */}

  {/* 中間：只有有 cuid 才出現，其餘保持不變 */}
  {hasCuid && (
    <>
      <Nav.Item
        className={cx("mobile-hide")}
        onClick={() => {
          onPageButtonClick("account");
        }}
      >
        <Button
          disabled={!cuid}
          variant="outline-primary"
          className={cx(
            "btn-radius",
            "nav-rounded",
            "customizedPadding",
            pageButton === "account" ? "active" : "",
            !cuid && "dis-active"
          )}
        >
          帳戶<span className={cx("mobile-hide")}>總覽</span>
        </Button>
      </Nav.Item>

      <Nav.Item
        className={cx("mobile-hide")}
        onClick={() => {
          onPageButtonClick("order");
        }}
      >
        <Button
          disabled={!cuid}
          variant="outline-primary"
          className={cx(
            "btn-radius",
            "nav-rounded",
            "customizedPadding",
            pageButton === "order" ? "active" : "",
            !cuid && "dis-active"
          )}
        >
          <span className={cx("mobile-hide")}>權證</span>下單
        </Button>
      </Nav.Item>

      <Nav.Item
        className={cx("mobile-hide")}
        onClick={() => {
          onPageButtonClick("selfSelect");
        }}
      >
        <Button
          disabled={!cuid}
          variant="outline-primary"
          className={cx(
            "btn-radius",
            "nav-rounded",
            "customizedPadding",
            pageButton === "selfSelect" ? "active" : "",
            !cuid && "dis-active"
          )}
        >
          自選<span className={cx("mobile-hide")}>清單</span>
        </Button>
      </Nav.Item>

      <Nav.Item
        className={cx("mobile-hide")}
        onClick={() => {
          onPageButtonClick("profited");
        }}
      >
        <Button
          disabled={!cuid}
          variant="outline-primary"
          className={cx(
            "btn-radius",
            "nav-rounded",
            "customizedPadding",
            pageButton === "profited" ? "active" : "",
            !cuid && "dis-active"
          )}
        >
          <span className={cx("mobile-hide")}>實現</span>績效
        </Button>
      </Nav.Item>

      <Nav.Item
        className={cx("mobile-hide")}
        onClick={() => {
          orderInquireOnClick();
        }}
      >
        <Button
          disabled={!cuid}
          variant="outline-primary"
          className={cx(
            "btn-radius",
            "nav-rounded",
            "customizedPadding",
            "position",
            pageButton === "orderInquire" ? "active" : "",
            !cuid && "dis-active"
          )}
        >
          委託<span className={cx("mobile-hide")}>查詢</span>{" "}
          {orderCount > 0 && (
            <span className={cx("badge")}>
              <Bell />
            </span>
          )}
        </Button>
      </Nav.Item>
        <Nav.Item
          className={cx("mobile-hide")}
          onClick={() => {
            onPageButtonClick("leaderboard");
          }}
        >
          <Button
            disabled={!cuid}
            variant="outline-primary"
            className={cx(
              "btn-radius",
              "nav-rounded",
              "customizedPadding",
              pageButton === "leaderboard" ? "active" : "",
              !cuid && "dis-active"
            )}
          >
            排行榜
          </Button>
        </Nav.Item>
    </>
  )}
  <Nav.Item className={cx("mobile-hide")}>
    <Button
      variant="outline-primary"
      disabled
      onClick={() => {
        !verify && onPageButtonClick("verify");
      }}
      className={cx(
        "nav-rounded",
        "customizedPadding",
        verify ? "verifyActive" : "noneVerify"
      )}
    >
      {verify ? (
        <>
          <Verifyok />
          資格已驗證
        </>
      ) : (
        "暫停手機驗證"
      )}
    </Button>
  </Nav.Item>
</Nav>

<div
  className={cx("desktop-hide")}
  style={{ paddingBottom: "5px" }}
>
  <Button
    variant="outline-primary"
    className={cx(
      "minWidth-55px",
      "w-100",
      "btn-radius",
      verify ? "verifyActive" : "noneVerify"
    )}
    disabled
  >
    {verify ? (
      <>
        <Verifyok />
        資格已驗證
      </>
    ) : (
      "暫停手機驗證"
    )}
  </Button>
</div>
      <Nav
        className={cx("justify-content-between", "desktop-w", "desktop-hide")}
      >
        <Nav.Item
          className={cx("desktop-hide", "width-16")}
          onClick={() => {
            cuid && onPageButtonClick("account");
          }}
        >
          <Button
            disabled={!cuid}
            variant="outline-primary"
            className={cx(
              "width-95",
              "btn-padding",
              "btn-radius",
              pageButton === "account" ? "active" : "",
              !cuid && "dis-active"
            )}
          >
            帳戶
          </Button>
        </Nav.Item>
        <Nav.Item
          className={cx("desktop-hide", "width-16")}
          onClick={() => {
            cuid && onPageButtonClick("order");
          }}
        >
          <Button
            disabled={!cuid}
            variant="outline-primary"
            className={cx(
              "width-95",
              "btn-padding",
              "btn-radius",
              pageButton === "order" ? "active" : "",
              !cuid && "dis-active"
            )}
          >
            下單
          </Button>
        </Nav.Item>
        <Nav.Item
          className={cx("desktop-hide", "width-16")}
          onClick={() => {
            cuid && onPageButtonClick("selfSelect");
          }}
        >
          <Button
            disabled={!cuid}
            variant="outline-primary"
            className={cx(
              "width-95",
              "btn-padding",
              "btn-radius",
              pageButton === "selfSelect" ? "active" : "",
              !cuid && "dis-active"
            )}
          >
            自選
          </Button>
        </Nav.Item>
        <Nav.Item
          className={cx("desktop-hide", "width-16")}
          onClick={() => {
            cuid && onPageButtonClick("profited");
          }}
        >
          <Button
            disabled={!cuid}
            variant="outline-primary"
            className={cx(
              "width-95",
              "btn-padding",
              "btn-radius",
              pageButton === "profited" ? "active" : "",
              !cuid && "dis-active"
            )}
          >
            績效
          </Button>
        </Nav.Item>
        <Nav.Item
          className={cx("desktop-hide", "width-16")}
          onClick={() => {
            cuid && orderInquireOnClick();
          }}
        >
          <Button
            disabled={!cuid}
            variant="outline-primary"
            className={cx(
              "width-95",
              "btn-padding",
              "btn-radius",
              "position",
              pageButton === "orderInquire" ? "active" : "",
              !cuid && "dis-active"
            )}
          >
            委託{" "}
            {orderCount > 0 && (
              <span className={cx("badge")}>
                <Bell />
              </span>
            )}
          </Button>
        </Nav.Item>
        {code === "school" ? (
          ""
        ) : (
          <Nav.Item
            className={cx("desktop-hide", "width-16")}
            onClick={() => {
              cuid && onPageButtonClick("leaderboard");
            }}
          >
            <Button
              disabled={!cuid}
              variant="outline-primary"
              className={cx(
                "width-95",
                "btn-padding",
                "btn-radius",
                pageButton === "leaderboard" ? "active" : "",
                !cuid && "dis-active"
              )}
            >
              榜單
            </Button>
          </Nav.Item>
        )}
      </Nav>
      {/* 實際登錄彈窗 */}
      <WarrantVerifyModel
        isOpen={isWarrantVerifyModalOpen}
        handleClose={handleWarrantVerifyModalClose}
        cu_id={cuIdForTradeLogin || ""}
        showQueryResult={showQueryResult}
        setShowQueryResult={setShowQueryResult}
      />
    </>
  );
};

export default Navigation;
